import { RecentCommunications } from "pages/home/components/CommunicationSection/RecentCommunicationsSection/components/RecentCommunications";
import { Column22, SectionTitle } from "pages/home/components/Layout";

export const RecentCommunicationsSection = ({ slicedData }) => {
  return (
    <Column22>
      <SectionTitle>최근 올라온 건의/문의</SectionTitle>
      <RecentCommunications slicedData={slicedData} />
    </Column22>
  );
};
